import { useState, useEffect } from 'react';
import { Stack } from '@/types';

export const useStacks = () => {
  const [stacks, setStacks] = useState<Stack[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStacks = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/v1/stacks');
      if (!response.ok) {
        throw new Error('Ошибка загрузки стеллажей');
      }
      const data = await response.json();
      setStacks(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
      console.error('Ошибка загрузки стеллажей:', err);
    } finally {
      setLoading(false);
    }
  };

  const createStack = async (stackData: Partial<Stack>) => {
    try {
      const response = await fetch('/api/v1/stacks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(stackData),
      });
      
      if (!response.ok) {
        throw new Error('Ошибка создания стеллажа');
      }
      
      const newStack = await response.json();
      setStacks(prev => [...prev, newStack]);
      return newStack;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка создания стеллажа');
      throw err;
    }
  };

  const updateStack = async (id: number, stackData: Partial<Stack>) => {
    try {
      const response = await fetch(`/api/v1/stacks/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(stackData),
      });
      
      if (!response.ok) {
        throw new Error('Ошибка обновления стеллажа');
      }
      
      const updatedStack = await response.json();
      setStacks(prev => prev.map(s => s.id === id ? updatedStack : s));
      return updatedStack;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка обновления стеллажа');
      throw err;
    }
  };

  useEffect(() => {
    fetchStacks();
  }, []);

  return {
    stacks,
    loading,
    error,
    fetchStacks,
    createStack,
    updateStack,
  };
};
